import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const plannerApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.PLANNER_POSTS],
	endpoints: {
		plannerPostsRetrieve: {
			providesTags: [EBaseApiTags.PLANNER_POSTS],
		},
		plannerPostsCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.PLANNER_POSTS]),
		},
		plannerPostsPartialUpdate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.PLANNER_POSTS]),
		},
		plannerPostsDestroy: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.PLANNER_POSTS]),
		},
	},
});

export const {
	usePlannerPostsRetrieveQuery,
	usePlannerPostsCreateMutation,
	usePlannerPostsPartialUpdateMutation,
	usePlannerPostsImagesListQuery,
	usePlannerPostsImagesCreateMutation,
	usePlannerPostsImagesRetrieveQuery,
	usePlannerPostsImagesDestroyMutation,
	usePlannerPostsDestroyMutation,
	usePlannerPostsPublicationsListQuery,
} = plannerApi;
